import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import CodesetSelect from "../../CodesetSelect";
import UuidPreview from "../../UuidPreview";
import CurrencyAmountInput from "../../CurrencyAmountInput";
import RateAmountInput from "../../RateAmountInput";
import PartySelectById from "../../PartySelectById";
import { createEmptyOtherDeduction } from "../../utils/placementDefaults";

const OtherDeductionEditor = ({ deduction, deductionIndex, onUpdate, onRemove }) => {
  const updateField = (field, value) => {
    onUpdate(deductionIndex, field, value);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} mb={6} borderColor="gray.500">
      <UuidPreview uuid={deduction.id} />

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <FormControl>
          <FormLabel>Description</FormLabel>
          <Input
            value={deduction.description || ""}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </FormControl>

        <CodesetSelect
          label="Type"
          codesetCode="A87"
          value={deduction.type ? { code: deduction.type, description: "" } : null}
          onChange={(value) => updateField("type", value.code)}
        />

        <FormControl>
          <FormLabel>Class Code</FormLabel>
          <Input
            value={deduction.classCode || ""}
            onChange={(e) => updateField("classCode", e.target.value)}
          />
        </FormControl>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <RateAmountInput
          label="Percentage"
          value={deduction.percentage}
          onChange={(value) => updateField("percentage", value)}
        />

        <CodesetSelect
          label="Basis"
          codesetCode="A88"
          value={deduction.basis ? { code: deduction.basis, description: "" } : null}
          onChange={(value) => updateField("basis", value.code)}
        />

        <CurrencyAmountInput
          label="Amount"
          value={deduction.amount}
          onChange={(value) => updateField("amount", value)}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <PartySelectById
          label="Payable To Party"
          value={deduction.payableToParty}
          onChange={(value) => updateField("payableToParty", value)}
        />

        <PartySelectById
          label="Payable By Party"
          value={deduction.payableByParty}
          onChange={(value) => updateField("payableByParty", value)}
        />

        <PartySelectById
          label="Service Provided To Party"
          value={deduction.serviceProvidedToParty}
          onChange={(value) => updateField("serviceProvidedToParty", value)}
        />
      </SimpleGrid>

      <HStack justify="flex-end" mt={4}>
        <IconButton
          size="md"
          icon={<HiOutlineTrash />}
          aria-label="Delete Other Deduction"
          onClick={() => onRemove(deductionIndex)}
        />
      </HStack>
    </Box>
  );
};

const OtherDeductionsEditor = ({ otherDeductions = [], onChange }) => {
  const updateDeduction = (deductionIndex, field, value) => {
    const updated = [...otherDeductions];
    updated[deductionIndex] = {
      ...updated[deductionIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addDeduction = () => {
    onChange([...otherDeductions, createEmptyOtherDeduction()]);
  };

  const removeDeduction = (deductionIndex) => {
    const updated = [...otherDeductions];
    updated.splice(deductionIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Other Deductions</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Other Deduction"
          onClick={addDeduction}
        />
      </HStack>

      {otherDeductions.map((deduction, deductionIndex) => (
        <OtherDeductionEditor
          key={deduction.id}
          deduction={deduction}
          deductionIndex={deductionIndex}
          onUpdate={updateDeduction}
          onRemove={removeDeduction}
        />
      ))}
    </Box>
  );
};

export default OtherDeductionsEditor;
